<template>
    <div>
        <div class="mb-3 pb-2">
            <span class="badge badge-highlight">
                <img src="/static/general/img/icons/shines.svg" height="11" class="align-middle mr-1" />
                <span class="align-middle">{{ labelsTranslated.aiGeneratedFeedback }}</span>
            </span>
            <span
                v-if="response.ai_gen_feedback.analysis_successful === false"
                class="icon icon-glyphicons-basic-circle-alert text-danger align-middle ml-1"
            ></span>
        </div>
        <markdown-display :markdown="response.ai_gen_feedback.feedback"></markdown-display>
        <div
            class="my-3 font-weight-500"
            v-if="panel.enable_ai_scoring && response.ai_gen_feedback.score !== undefined"
        >
            <div class="d-flex align-items-center">
                <div class="flex-grow-0 mr-3" v-if="scorePercentStyle !== undefined">
                    <div class="progress score-bar">
                        <div
                            class="progress-bar"
                            role="progressbar"
                            :style="scorePercentStyle"
                            aria-valuemin="0"
                            aria-valuemax="100"
                            aria-label="Response score"
                        ></div>
                    </div>
                </div>
                <div class="flex-grow-0 mr-3">
                    <span class="text-primary">
                        <span class="mr-1">{{ labelsTranslated.yourScore }}:</span>
                        <span>{{ response.ai_gen_feedback.score }}</span
                        ><span v-if="response.max_ai_score"
                            ><span class="px-1">/</span>{{ response.max_ai_score }}</span
                        ></span
                    >
                </div>
            </div>
        </div>
        <div v-if="response.ai_gen_feedback.score_rationale">
            <markdown-display :markdown="response.ai_gen_feedback.score_rationale"></markdown-display>
        </div>
    </div>
</template>

<script>
import MarkdownDisplay from "@/components/MarkdownDisplay"

export default {
    name: "TextResponseAiFeedback",
    props: {
        panel: {
            type: Object,
            required: true,
        },
        response: {
            type: Object,
            required: true,
        },
    },
    components: {
        MarkdownDisplay,
    },
    computed: {
        labelsTranslated() {
            return this.$store.getters.sessionLabelsTranslated
        },
        scorePercentStyle() {
            if (!this.response || this.response.max_ai_score == 0) {
                return undefined
            }
            let scorePercent = (this.response.ai_gen_feedback.score * 100) / this.response.max_ai_score
            return {
                width: scorePercent + "%",
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.score-bar {
    height: 9px;
    width: 110px;
}
</style>